module.exports = __webpack_public_path__ + "static/media/Statua_053.0a4dc7ca.jpg";